"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RefreshButton;
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function RefreshButton(_ref) {
  var isRotating = _ref.isRotating,
    refreshTags = _ref.refreshTags,
    className = _ref.className;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("span", {
      className: (0, _classnames["default"])('wpf-select-refresh dashicons dashicons-update', {
        'wpf-select-rotating': isRotating,
        className: className
      }),
      onClick: refreshTags,
      role: "button",
      tabIndex: "0"
    })
  );
}